// extracted by mini-css-extract-plugin
export default {"TrusteesInfo":"TrusteesInfo_TrusteesInfo__npw7b","PageName":"TrusteesInfo_PageName__RViAV"};